import React, { useState, useEffect } from "react";
import moment from "moment";
import Chart from "react-apexcharts";
// import Loading from "./common/loading";

const ProfileChart = ({ data }) => {
  const [series, setSeries] = useState([]);
  const options = {
    chart: {
      id: "basic-scatter",
      toolbar: {
        tools: {
          download: false,
          pan: false
        }
      }
    },
    colors: [
      "#1abc9c",
      "#f1c40f",
      "#2ecc71",
      "#e67e22",
      "#3498db",
      "#e74c3c",
      "#9b59b6",
      "#16a085",
      "#f39c12",
      "#27ae60",
      "#d35400",
      "#2980b9",
      "#c0392b",
      "#8e44ad"
    ],
    title: { text: "Data Screen Access Log" },
    subtitle: { text: "Past 7 Days", floating: true },
    xaxis: {
      type: "datetime",
      tooltip: { formatter: d => moment(d).format("ddd Do MMM HH:mm:ss") }
    },
    yaxis: {
      labels: { show: false }
    },
    grid: { show: false },
    tooltip: {
      theme: "dark",
      x: { show: false },
      y: { formatter: () => "" }
    }
  };

  useEffect(() => {
    if (data.length === 0) return;

    setSeries(
      data.map((screen, y) => {
        return {
          name: screen.DESCRIPTION,
          data: screen.DATES.map(d => {
            return { x: moment(d), y: y + 1 };
          })
        };
      })
    );
  }, [data]);
  return (
    <div>
      <Chart options={options} series={series} type={"scatter"} height="300" />
    </div>
  );
};

export default ProfileChart;
